/** Formatta data email (ISO o header) in italiano leggibile. */
export function formatMailDate(raw?: string | number | null): string {
  if (raw == null || raw === '') return '—';
  let d: Date | null = null;
  if (typeof raw === 'number') {
    d = new Date(raw > 1e12 ? raw : raw * 1000);
  } else {
    const n = Number(raw);
    if (!Number.isNaN(n) && /^\d+$/.test(String(raw).trim())) {
      d = new Date(n > 1e12 ? n : n * 1000);
    } else {
      d = new Date(raw);
    }
  }
  if (!d || Number.isNaN(d.getTime())) return String(raw);
  return new Intl.DateTimeFormat('it-IT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}

export function mailDateMs(raw?: string | number | null): number {
  if (raw == null || raw === '') return 0;
  if (typeof raw === 'number') return raw > 1e12 ? raw : raw * 1000;
  const n = Number(raw);
  if (!Number.isNaN(n) && /^\d+$/.test(String(raw).trim())) {
    return n > 1e12 ? n : n * 1000;
  }
  const t = Date.parse(String(raw));
  return Number.isNaN(t) ? 0 : t;
}
